// extracted by mini-css-extract-plugin
export default {"button":"DFMControls_button__cS4YO"};